import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
    COOKIE_CONSENT_ACCEPTED,
    COOKIE_CONSENT_CHANGE_EVENT,
    initializeAnalytics,
    trackPageView,
} from "../utils/analytics";

export default function AnalyticsTracker() {
    const location = useLocation();
    const pagePath = `${location.pathname}${location.search}${location.hash}`;

    useEffect(() => {
        initializeAnalytics();
    }, []);

    useEffect(() => {
        trackPageView(pagePath);
    }, [pagePath]);

    useEffect(() => {
        function handleConsentChange(event) {
            if (event.detail?.status === COOKIE_CONSENT_ACCEPTED) {
                trackPageView(pagePath);
            }
        }

        window.addEventListener(COOKIE_CONSENT_CHANGE_EVENT, handleConsentChange);
        return () => window.removeEventListener(COOKIE_CONSENT_CHANGE_EVENT, handleConsentChange);
    }, [pagePath]);

    return null;
}
